<template>
  <div class="top-action-bar d-flex align-items-center justify-content-between flex-wrap mb-1">
    <div class="action-bar-left d-flex align-items-center flex-wrap" style="gap: 0.5rem;">
      <b-button
        size="sm"
        :variant="activeFiltersCount > 0 ? 'primary' : 'outline-secondary'"
        @click="$emit('toggle-filters')"
      >
        <feather-icon icon="FilterIcon" size="14" />
        <span class="ml-25">Filtros</span>
        <b-badge v-if="activeFiltersCount > 0" pill class="ml-50 badge-translucent">
          {{ activeFiltersCount }}
        </b-badge>
      </b-button>

      <b-button-group size="sm">
        <b-button
          :variant="activeTab === 0 ? 'primary' : 'outline-secondary'"
          :disabled="isLoading"
          @click="$emit('change-tab', 0)"
        >
          <span>Pedidos</span>
          <b-badge
            v-if="totalPedidos > 0"
            :variant="activeTab === 0 ? null : 'light-secondary'"
            pill
            class="ml-50"
            :class="{ 'badge-translucent': activeTab === 0 }"
          >
            {{ formatCount(totalPedidos) }}
          </b-badge>
        </b-button>
        <b-button
          v-if="$store.getters['preferencias/rascunhoPermitido']"
          :variant="activeTab === 1 ? 'primary' : 'outline-secondary'"
          :disabled="isLoading"
          @click="$emit('change-tab', 1)"
        >
          <span>Rascunhos</span>
          <b-badge
            v-if="totalRascunhos > 0"
            :variant="activeTab === 1 ? null : 'light-secondary'"
            pill
            class="ml-50"
            :class="{ 'badge-translucent': activeTab === 1 }"
          >
            {{ formatCount(totalRascunhos) }}
          </b-badge>
        </b-button>
      </b-button-group>
    </div>

    <div class="action-bar-right d-flex align-items-center flex-wrap" style="gap: 0.5rem;">
      <div class="d-flex align-items-center" style="gap: 0.25rem;">
        <label class="mb-0 small text-muted">Exibir:</label>
        <b-form-select
          size="sm"
          :value="pageSize"
          :options="[10, 20, 50, 100]"
          style="width: auto;"
          @change="$emit('change-page-size', parseInt($event))"
        />
      </div>

      <b-button-group size="sm">
        <b-button
          v-for="view in views"
          :key="view.id"
          :variant="currentView === view.id ? 'primary' : 'outline-secondary'"
          :title="view.label"
          @click="$emit('change-view', view.id)"
        >
          <feather-icon :icon="view.icon" size="14" />
        </b-button>
      </b-button-group>

      <b-button
        size="sm"
        variant="outline-secondary"
        title="Exportar pedidos exibidos (CSV / Excel)"
        :disabled="isExporting"
        @click="$emit('export')"
      >
        <feather-icon icon="DownloadIcon" size="14" />
        <span class="ml-25">{{ isExporting ? 'Exportando...' : 'Exportar' }}</span>
      </b-button>

      <b-button size="sm" variant="primary" @click="$emit('new-order')">
        <feather-icon icon="PlusIcon" size="14" />
        <span class="ml-25">Novo Pedido</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BButton, BButtonGroup, BBadge, BFormSelect,
} from 'bootstrap-vue';

export default {
  name: 'TopActionBar',
  components: {
    BButton, BButtonGroup, BBadge, BFormSelect,
  },
  props: {
    currentView: { type: String, default: 'list' },
    activeFiltersCount: { type: Number, default: 0 },
    activeTab: { type: Number, default: 0 },
    totalPedidos: { type: Number, default: 0 },
    totalRascunhos: { type: Number, default: 0 },
    isLoading: { type: Boolean, default: false },
    isExporting: { type: Boolean, default: false },
    pageSize: { type: Number, default: 20 },
  },
  data() {
    return {
      views: [
        { id: 'list', icon: 'ListIcon', label: 'Lista' },
        { id: 'kanban', icon: 'TrelloIcon', label: 'Kanban' },
        { id: 'cards', icon: 'GridIcon', label: 'Cards' },
      ],
    };
  },
  methods: {
    formatCount(count) {
      if (count >= 10000) {
        return `${Math.floor(count / 1000)}k`;
      }
      return count.toLocaleString('pt-BR');
    },
  },
};
</script>

<style scoped>
.top-action-bar {
  gap: 0.75rem;
}

/* Contador dentro do botão ativo: translúcido em vez do pill branco chapado */
.badge-translucent {
  background-color: rgba(255, 255, 255, 0.22) !important;
  color: #fff !important;
}
</style>
